import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'miejscowosci/';

export default {

    getMiejscowosci() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    addMiejscowosc(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editMiejscowosc(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteMiejscowosc(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/miejscowosci/MiejscowosciService.js